<template>
  <div class="input-group" :class="{'input-group-invalid': isInvalid, 'input-group-disabled': isDisabled}">
    <label>
      <FieldLabel :is-required="isRequired" :label-link-text="labelLinkText" :label-link-url="labelLinkUrl"><slot>{{ label }}</slot></FieldLabel>
      <input
          type="text"
          :disabled="isDisabled"
          :placeholder="placeholder"
          v-model="inputValue"
          @blur="() => validate()"
          @input="() => inputHandle()"
      >
    </label>
  </div>
</template>

<script>
import {defaultProps} from "./defaultProps";

export default {
  name: "i-text",
  props: {...defaultProps},
  data: () => ({
    inputValue: null,
    isInvalid: false,
    hasTouched: false,
  }),
  methods: {
    inputHandle() {
      this.hasTouched = true;
      this.$emit('input', this.inputValue);
    },
    validate() {
      this.isInvalid = (this.hasTouched && this.inputValue === null)
          || (this.isRequired && !this.inputValue);
    },
    clean() {
      this.inputValue = null;
      this.isInvalid = false;
      this.hasTouched = false;
    },
    isValid() {
      this.validate();
      return !this.isInvalid;
    },
  },
  watch: {
    value: {
      handler(v) {
        this.inputValue = v;
      },
      immediate: true,
    },  },
}
</script>

<style scoped>

</style>
